import { Typography } from "antd";
import { useNavigate } from "react-router-dom";

import CustomImage from "../../shared/custom-image/custom-image";
import CustomButton from "../../shared/custom-button/custom-button";
import { TEASER_HOME_DATA } from "../../constants/content/components/teaser-home";
import { routes } from "../../constants/routes";
import { VIEWS } from "../../constants/global";

import { BUTTON_VARIANTS } from "../../constants/styles";

import "./styles.scss";

const { Title } = Typography;

const TeaserHome = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate(routes[VIEWS.ABOUT_US].staticPath);
  };

  return (
    <div className="TeaserHome">
      <CustomImage
        className="TeaserHome-image"
        src={TEASER_HOME_DATA.imageSrc}
      />
      <div className="TeaserHome-content">
        <div className="TeaserHome-content-title">
          <Title className="mb-3xs">
            <span className="TeaserHome-title-line">Smart Thinking,</span>
            <span className="TeaserHome-title-line">Bold Coding.</span>
          </Title>
        </div>
        <CustomButton
          className="TeaserHome-content-button"
          btnVariant={BUTTON_VARIANTS.SECONDARY}
          onClick={handleExploreClick}
        >
          {TEASER_HOME_DATA.buttonText}
        </CustomButton>
      </div>
    </div>
  );
};

export default TeaserHome;
